import NavigationBreadcrumbs from '@/components/navigation-breadcrumbs';
import { Divider, Skeleton, Stack, Typography } from '@mui/material';

import dayjs from 'dayjs';
import React, { FC, useMemo } from 'react';

type HeaderProps = {
  date: string;
  flowSubtype: string;
  payGroupName: string;
  payGroupCode?: string;
  isLoading?: boolean;
  planId: number;
  planName?: string;
  startedBy?: string;
  activityCreatedAt?: string;
};

export const Header: FC<HeaderProps> = props => {
  const type = useMemo(
    () =>
      ({
        'off-cycle_supplemental_pay': 'Off-Cycle',
        regular: 'Regular'
      })[props.flowSubtype],
    [props.flowSubtype]
  );

  const paths = useMemo(
    () => [
      {
        name: 'Plans',
        to: '/plans'
      },
      {
        name: props.planName ?? '--',
        to: `/plans/${props.planId}/contributions`
      }
    ],
    [props.planId, props.planName]
  );

  const activityCreatedAt = useMemo(
    () =>
      props.activityCreatedAt
        ? dayjs(props.activityCreatedAt).format('MM/DD/YYYY HH:mm ')
        : null,
    [props.activityCreatedAt]
  );

  return (
    <Stack data-testid='header' gap={0.5}>
      <NavigationBreadcrumbs data-testid='header-breadcrumbs' paths={paths} />
      <Typography data-testid='header-title' variant='h4'>
        {props.isLoading ? (
          <Skeleton width={600} />
        ) : (
          `${props.date} ${type} Contribution`
        )}
      </Typography>
      <Typography data-testid='header-paygroup'>
        {props.isLoading ? (
          <Skeleton width={300} />
        ) : (
          <Stack display='flex' flexDirection='row' gap={1}>
            <Typography>
              Paygroup: {props.payGroupName} (code:{' '}
              {props.payGroupCode || 'null'})
            </Typography>
            <Divider flexItem orientation='vertical' />
            <Typography>
              Created by {props.startedBy ?? '--'} at{' '}
              {activityCreatedAt ?? '--'}
            </Typography>
          </Stack>
        )}
      </Typography>
    </Stack>
  );
};
